let $rangeSlider;
let hasUsedSort = false;

const wNumbPrice = wNumb({
    decimals: 0,
    suffix: Eshop.options.currency.symbol_right
});

FilterBubbles.create = function(filterSelector, options) {
    this.template = options.template;
    this.clearFilterTemplate = options.clearFilterTemplate;

    this.initialize();

    return this;
}

FilterBubbles.add = function(data) {
    if (!data.content) {
        return;
    }

    if ($(this.container).find('.js-filter-bubbles-reset').length == 0) {
        $(this.container).prepend( _.template(this.clearFilterTemplate)({
            _class: ''
        }) );
    }

    $(this.container).append( _.template(this.template)(data));
    $('[data-element="filterBubbles"]').attr('data-count', $(this.holder + ':not(.is-reset)').size());

    updateFilterBubbles();
}

FilterBubbles.remove = function() {
    $(this.holder).remove();

    updateFilterBubbles();
}

function updateFilterBubbles() {
    const $bubblesItems = $('.js-filter-bubbles-item'),
        $bubblesReset = $('.js-filter-bubbles-reset'),
        $bubblesWrapper = $('.js-filter-bubbles-wrapper');

    $('[data-element="filterBubbles"]').attr('data-count', $bubblesItems.length);

    if ($bubblesItems.length < 1) {
        $bubblesReset.remove();
        $bubblesWrapper.removeClass('is-visible');
    } else {
        $bubblesWrapper.addClass('is-visible');
    }
}

rEvent.on('FilterBubbles.created', function() {
    updateFilterBubbles();
});

rEvent.on('FilterBubbles.added', function() {
    updateFilterBubbles();
});

rEvent.on("Filter.reset", function () {
    if ($rangeSlider) {
        $rangeSlider.set([$('[name="filter[price][from]"]').attr('min'), $('[name="filter[price][to]"]').attr('max')]);
    }
});

function updateRangeCallback(selectors, values, sliderInstance) {
    const $from = $(selectors.from);
    const $to = $(selectors.to);
    const fromVal = parseInt($from.val());
    const toVal = parseInt($to.val());
    const minValue = parseInt(sliderInstance.options.range.min[0]);
    const maxValue = parseInt(sliderInstance.options.range.max[0]);
    const valueFrom = parseInt(values[0]);
    const valueTo = parseInt(values[1]);

    // if (minValue == valueFrom && maxValue == valueTo) {
    //     $from.val('').removeAttr('value');
    //     $to.val('').removeAttr('value');

    //     Filter.submit();

    //     return true;
    // }

    $from.val(values[0]);
    $to.val(values[1]);
    $('.js-price-from-value').html(values[0]);
    $('.js-price-to-value').html(values[1]);

    // if (!fromVal && !toVal) {
    //     $to.trigger('change');
    // }
    // else if (fromVal === valueFrom) {
    //     $to.trigger('change');
    // }
    // else if (toVal === valueTo) {
    //     $from.trigger('change');
    // }

    Filter.submit();
}

function createPriceRange() {
    const $elem = $('.js-range-price');
    const $slider = $elem.find('.range-slider__slider');
    const maxValue = parseInt($elem.attr('data-max'));
    const minValue = parseInt($elem.attr('data-min'));
    const fromValue = parseInt($elem.attr('data-from'));
    const toValue = parseInt($elem.attr('data-to'));

    if (!$slider.length) {
        return false;
    }

    $rangeSlider = noUiSlider.create($slider[0], {
        start: [fromValue, toValue],
        range: {
            'min': [minValue],
            'max': [maxValue]
        },
        margin: 1,
        connect: true,
        tooltips: [
            wNumbPrice,
            wNumbPrice
        ],
        format: wNumbPrice,
        step: 1
    });

    $rangeSlider.on('change', function (values, handle) {
        if (!hasUsedSort) {
            $('select[name="filter[sort]"]').val('price:d').multiselect('refresh');
        }

        updateRangeCallback({
            from: '[name="filter[price][from]"]',
            to: '[name="filter[price][to]"]'
        }, values, this);
    });

    $('#filter-price-from').on('focus', function () {
        if (!this.value) return
        $(this).val(wNumbPrice.from(this.value) || this.min);
    });
    $('#filter-price-from').on('blur', function () {
        if (!this.value) return
        $(this).val(wNumbPrice.to(parseInt(this.value) || parseInt(this.min)));
    });
    $('#filter-price-from').on('keydown keyup blur', function () {
        $('.js-price-from-value').html(wNumbPrice.to(parseInt(this.value) || parseInt(this.min)));
    });
    $('#filter-price-from').on('change', function () {
        const $priceToInput = $('#filter-price-to');
        const min = parseInt($(this).attr('min'));
        const max = parseInt($priceToInput.attr('max'));
        const inputToValue = parseInt($priceToInput.val());
        const hasInputToValue = typeof inputToValue === 'number' && !isNaN(inputToValue)

        let value = parseInt($(this).val());

        if (!value || value < min) {
            value = min;
        }
        else if (value > inputToValue) {
            value = inputToValue;
        }

        $(this).val(wNumbPrice.to(value));
        $('.js-price-from-value').html(wNumbPrice.to(value));

        if (!hasInputToValue) {
            $priceToInput.val(wNumbPrice.to(max));
            $('.js-price-from-value').html(wNumbPrice.to(max));
        }

        if (!hasUsedSort) {
            $('select[name="filter[sort]"]').val('price:d').multiselect('refresh');
        }

        $rangeSlider.set([value, null]);
    });

    $('#filter-price-to').on('focus', function () {
        if (!this.value) return
        $(this).val(wNumbPrice.from(this.value) || this.max);
    });
    $('#filter-price-to').on('blur', function () {
        if (!this.value) return
        $(this).val(wNumbPrice.to(parseInt(this.value) || parseInt(this.max)));
    });
    $('#filter-price-to').on('keydown keyup blur', function () {
        $('.js-price-to-value').html(wNumbPrice.to(parseInt(this.value) || parseInt(this.max)));
    });
    $('#filter-price-to').on('change', function () {
        const $priceFromInput = $('#filter-price-from');
        const min = parseInt($priceFromInput.attr('min'));
        const max = parseInt($(this).attr('max'));
        const inputFromValue = parseInt($priceFromInput.val());
        const hasInputFromValue = typeof inputFromValue === 'number' && !isNaN(inputFromValue)

        let value = parseInt($(this).val());

        if (!value || value > max) {
            value = max;
        }
        else if (value < inputFromValue) {
            value = inputFromValue;
        }

        $(this).val(wNumbPrice.to(value));
        $('.js-price-to-value').html(wNumbPrice.to(value));

        if (!hasInputFromValue) {
            $priceFromInput.val(wNumbPrice.to(min));
            $('.js-price-from-value').html(wNumbPrice.to(min));
        }

        if (!hasUsedSort) {
            $('select[name="filter[sort]"]').val('price:d').multiselect('refresh');
        }

        $rangeSlider.set([null, value]);
    });
}

function toggleFilter() {
    const $subFilter = $('.js-target-filter'),
        $subFilterTrigger = $('.js-trigger-filter'),
        $triggerIcon = $('.js-filter-icon'),
        $filterWrapper = $('.js-filter-wrapper'),
        $body = $('body');

    if ($subFilter.hasClass('is-active')) {
        $subFilter.removeClass('is-active');
        $subFilterTrigger.removeClass('is-active');
        $filterWrapper.removeClass('is-open');

        $triggerIcon.removeClass('ico-cross');
        $triggerIcon.addClass('ico-filter');

        if (checkResolution('cxs;xs')) {
            $subFilter.hide();
            unfreezeScroll();
            $body.removeClass('is-overlayed');
        } else {
            $subFilter.slideUp(150);
        }
    }
    else {
        $subFilter.addClass('is-active');
        $subFilterTrigger.addClass('is-active');
        $filterWrapper.addClass('is-open');

        $triggerIcon.removeClass('ico-filter');
        $triggerIcon.addClass('ico-cross');

        if (checkResolution('cxs;xs')) {
            $subFilter.show();
            $body.addClass('is-overlayed');
            freezeScroll();
        } else {
            $subFilter.slideDown(150);
        }
    }
}

function filterReset() {
    Filter.reset();

    updateFilterBubbles();

    setTimeout(function() {
        updateFilterBubbles();
    }, 1);
}

$(function() {
    if ($('.js-range-price').length > 0) {
        createPriceRange();
    }

    // nech je filter otvoreny po nacitani stranky
    if ($('.js-trigger-filter').length > 0 && !$('.js-trigger-filter').is(':disabled') && !$('.js-trigger-filter').hasClass('is-active') && !checkResolution('cxs;xs')) {
        toggleFilter();
    }

    tippy('.js-filter-tippy', {
        arrow: true,
        theme: 'filter',
        performance: true,
        maxWidth: 'calc(100% - 30px)'
    });

    $('.js-catalog-header-subcategories .js-category-item.is-more').on('click', function() {
        $(this).toggleClass('is-open');
        $('.js-catalog-header-subcategories').find('[data-hidden]').toggleClass('is-hidden');

        $(this).blur();
    });

    $('.js-trigger-filter, .js-close-filter').on('click', function(e) {
        e.preventDefault();

        if (!$(this).hasClass('is-disabled')) {
            toggleFilter();
        }
    });

    $('.js-filter-show-results').on('click', function() {
        if ($('.js-target-filter').hasClass('is-active')) {
            $('.js-trigger-filter').slideHere(60);
        }

        toggleFilter();
    });

    $(".js-tabs-content").on("ruiTabShowed", function(event) {
        event.preventDefault();
    });

    $('body').on('change', '.filter__form [type="checkbox"]', function() {
        updateFilterBubbles();
    });

    // filter bubbles reset hide
    $('body').on('click', '.js-filter-bubbles-item', function() {
        updateFilterBubbles();

        setTimeout(function() {
            updateFilterBubbles();
        }, 1);
    });

    $('body').on('click', '.js-filter-bubbles-reset', function(e) {
        filterReset();

        updateFilterBubbles();
    });

    $('select[name="filter[sort]"]').on('change', function() {
        hasUsedSort = true
    });
});
